export default {
    title: '수업 만들기',
    semester: {
        first: '1학기',
        second: '2학기',
    },
    unit: {
        all: '대단원 전체',
    },
    filter: {
        initial: '필터 초기화',
        recommended: '추천 수업',
        search: {
            placeholder: '활동 검색',
            label: '검색',
        },
        all: '전체 선택',
        total: '조회된 활동 {count}개',
        basket: '{count}개 활동 담기',
        recommendedAdd: '추천 수업 담기',
    },
    session: {
        title: '수업 만들기',
        count: '{count} / {max}',
        delete: '비우기',
        empty: '활동 목록에서 카드를 클릭하여\n 수업에 담아보세요.',
        summary: {
            all: '전체 활동',
            self: '자습 가능 활동',
        },
    },
    buttons: {
        all: '전체 활동 {count}개',
        self: '자습 가능 활동 {count}개',
        startLecture: '수업 시작',
        startSelf: '자습 시작 ({count})',
    },
    modal: {
        title: '수업 제목 정하기',
        titleMessage: '제목을 입력하지 않으면 위 이름으로 자동 설정됩니다.',
        limitMessage: '한 수업에 최대 {count}개 활동까지\n담을 수 있어요.',
        cancel: '취소',
        start: '시작하기',
        emptyMessage: '활동을 하나 이상 추가해 주세요.',
        noSelfStudyMessage: '자습이 가능한 활동이 없습니다.',
        errorTitle: '오류 발생',
        errorMessage: '수업을 시작하는 중 오류가 발생했습니다.',
        delete: {
            title: '전체 삭제',
            message: '추가된 모든 활동을 삭제하시겠습니까?',
        },
    },
    noModules: '활동 목록이 없어요',
};
